import DATA_INTRO_STS from "./Introduction/101DataIntroSTS";

const STS_WORKFLOW = [
  { page: 101, type: "intro-template" as TemplateType, data: DATA_INTRO_STS },
];

export default STS_WORKFLOW;
